module.exports = __webpack_public_path__ + "static/img/ent-detail-81.2616835.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-81.jpg
// module id = qnW5
// module chunks = 51